import type { FulfillmentLineFilters, FulfillmentOrderListFilters } from "../types";

export const FULFILLMENT_ORDER_PERMISSIONS = {
  access: "fulfillment.order:access",
  create: "fulfillment.order:create",
  update: "fulfillment.order:update",
  finalize: "fulfillment.order:finalize",
  export: "fulfillment.order:export",
  archive: "fulfillment.order:archive",
} as const;

export const DEFAULT_FULFILLMENT_ORDER_LIST_FILTERS: FulfillmentOrderListFilters = {};
export const DEFAULT_FULFILLMENT_LINE_FILTERS: FulfillmentLineFilters = {
  resourceType: "all",
  assignment: "all",
  sourceDifferenceOnly: false,
};

export const FULFILLMENT_RESOURCE_OPTIONS = [
  { label: "全部", value: "all" },
  { label: "住宿", value: "住宿" },
  { label: "大交通", value: "大交通" },
  { label: "包车", value: "包车" },
  { label: "考察点", value: "考察点" },
  { label: "餐", value: "餐" },
  { label: "导游", value: "导游" },
  { label: "杂费", value: "杂费" },
] as const;

export const FULFILLMENT_PRICING_UNIT_OPTIONS = [
  { label: "按房晚计价", value: "room_night" },
  { label: "按餐次计价", value: "person_meal" },
  { label: "按人天计价", value: "person_day" },
  { label: "按单位计价", value: "unit" },
] as const;

export const FULFILLMENT_LINE_CATEGORY_OPTIONS = [
  { label: "全部", value: "all" },
  { label: "住宿", value: "stay" },
  { label: "大交通", value: "transport" },
  { label: "包车", value: "charter" },
  { label: "考察点", value: "ticket" },
  { label: "餐", value: "meal" },
  { label: "导游", value: "guide" },
] as const;

export type FulfillmentLineCategory =
  | (typeof FULFILLMENT_LINE_CATEGORY_OPTIONS)[number]["value"]
  | "other"
  | "unassigned";

export const FULFILLMENT_STATUS_LABELS: Readonly<Record<string, string>> = {
  active: "当前",
  draft: "草稿",
  finalized: "已定稿",
  effective: "已生效",
};

export const FULFILLMENT_STATUS_OPTIONS = [
  { label: "草稿", value: "draft" },
  { label: "已生效", value: "effective" },
] as const;
